<div class="challenge-timeline" [class.challenge-timeline--mobile]="variant === 'mobile'">
  <div class="challenge-timeline--track">
    <h3 class="challenge-timeline--heading">Timeline</h3>
    <!-- Start -->
    <div class="challenge-timeline--item">
      <div class="challenge-timeline--content">
        <div class="challenge-timeline--dot-wrapper">
          <div class="challenge-timeline--dot" [ngClass]="getTimelineDotClass(timelineDates.start, 'start')"></div>
          <div class="challenge-timeline--line challenge-timeline--line-dashed"></div>
        </div>
        <div class="challenge-timeline--text">
          <div class="challenge-timeline--label">Start</div>
          <div class="challenge-timeline--date" [class.challenge-timeline--date-completed]="isDateCompleted(timelineDates.start)">{{ formatTimelineDate(timelineDates.start) }}</div>
        </div>
      </div>
    </div>
    
    <!-- Submission Start -->
    <div class="challenge-timeline--item">
      <div class="challenge-timeline--content">
        <div class="challenge-timeline--dot-wrapper">
          <div class="challenge-timeline--dot" [ngClass]="getTimelineDotClass(timelineDates.submissionStart, 'submissionStart')"></div>
          <div class="challenge-timeline--line challenge-timeline--line-dashed"></div>
        </div>
        <div class="challenge-timeline--text">
          <div class="challenge-timeline--label">Submission Start</div>
          <div class="challenge-timeline--date" [class.challenge-timeline--date-completed]="isDateCompleted(timelineDates.submissionStart)">{{ formatTimelineDate(timelineDates.submissionStart) }}</div>
        </div>
      </div>
    </div>
    
    <!-- Submission End -->
    <div class="challenge-timeline--item">
      <div class="challenge-timeline--content">
        <div class="challenge-timeline--dot-wrapper">
          <div class="challenge-timeline--dot" [ngClass]="getTimelineDotClass(timelineDates.submissionEnd, 'submissionEnd')"></div>
          <div class="challenge-timeline--line challenge-timeline--line-dashed"></div>
        </div>
        <div class="challenge-timeline--text">
          <div class="challenge-timeline--label">Submission End</div>
          <div class="challenge-timeline--date" [class.challenge-timeline--date-completed]="isDateCompleted(timelineDates.submissionEnd)">{{ formatTimelineDate(timelineDates.submissionEnd) }}</div>
        </div>
      </div>
    </div>
    
    <!-- Evaluation End -->
    <div class="challenge-timeline--item challenge-timeline--item-last">
      <div class="challenge-timeline--content">
        <div class="challenge-timeline--dot-wrapper">
          <div class="challenge-timeline--dot" [ngClass]="getTimelineDotClass(timelineDates.evaluationEnd, 'evaluationEnd')"></div>
        </div>
        <div class="challenge-timeline--text">
          <div class="challenge-timeline--label">Evaluation End</div>
          <div class="challenge-timeline--date" [class.challenge-timeline--date-completed]="isDateCompleted(timelineDates.evaluationEnd)">{{ formatTimelineDate(timelineDates.evaluationEnd) }}</div>
        </div>
      </div>
    </div>
  </div>
</div>


